type RawSql = (query: string, params?: unknown[]) => Promise<unknown>;

export async function ensurePlatformAnalyticsSchema(params: { rawSql: RawSql }): Promise<void> {
  await params.rawSql(`CREATE TABLE IF NOT EXISTS analytics_sites (
        id SERIAL PRIMARY KEY,
        app_id INTEGER NOT NULL,
        site_key TEXT NOT NULL UNIQUE,
        backend TEXT NOT NULL DEFAULT 'disabled',
        enabled BOOLEAN NOT NULL DEFAULT false,
        primary_domain TEXT,
        custom_domain TEXT,
        last_event_at TIMESTAMP,
        metadata_json TEXT NOT NULL DEFAULT '{}',
        created_at TIMESTAMP DEFAULT NOW() NOT NULL,
        updated_at TIMESTAMP DEFAULT NOW() NOT NULL
    )`);
  await params.rawSql(
    `CREATE UNIQUE INDEX IF NOT EXISTS analytics_sites_app_id_unique ON analytics_sites (app_id)`,
  );
  await params.rawSql(
    `CREATE INDEX IF NOT EXISTS analytics_sites_app_updated_idx ON analytics_sites (app_id, updated_at DESC)`,
  );
  await params.rawSql(`CREATE INDEX IF NOT EXISTS analytics_sites_enabled_idx ON analytics_sites (enabled)`);

  await params.rawSql(`CREATE TABLE IF NOT EXISTS analytics_events_raw (
        id SERIAL PRIMARY KEY,
        site_id INTEGER NOT NULL,
        app_id INTEGER NOT NULL,
        schema_version INTEGER NOT NULL DEFAULT 1,
        event_name TEXT NOT NULL,
        day DATE NOT NULL,
        occurred_at TIMESTAMP DEFAULT NOW() NOT NULL,
        received_at TIMESTAMP DEFAULT NOW() NOT NULL,
        url TEXT NOT NULL,
        path TEXT NOT NULL,
        referrer TEXT,
        source TEXT NOT NULL DEFAULT 'Direct',
        country TEXT NOT NULL DEFAULT 'Unknown',
        device TEXT NOT NULL DEFAULT 'Unknown',
        browser TEXT NOT NULL DEFAULT 'Unknown',
        os TEXT NOT NULL DEFAULT 'Unknown',
        language TEXT,
        screen_width_bucket TEXT,
        screen_height_bucket TEXT,
        deploy_id TEXT,
        visitor_key TEXT NOT NULL,
        session_key TEXT NOT NULL,
        user_agent_hash TEXT,
        metadata_json TEXT NOT NULL DEFAULT '{}'
    )`);
  await params.rawSql(`CREATE INDEX IF NOT EXISTS analytics_events_site_day_idx ON analytics_events_raw (site_id, day)`);
  await params.rawSql(
    `CREATE INDEX IF NOT EXISTS analytics_events_site_occurred_idx ON analytics_events_raw (site_id, occurred_at)`,
  );
  await params.rawSql(
    `CREATE INDEX IF NOT EXISTS analytics_events_site_received_idx ON analytics_events_raw (site_id, received_at DESC)`,
  );
  await params.rawSql(
    `CREATE INDEX IF NOT EXISTS analytics_events_site_visitor_idx ON analytics_events_raw (site_id, day, visitor_key)`,
  );
  await params.rawSql(
    `CREATE INDEX IF NOT EXISTS analytics_events_site_session_idx ON analytics_events_raw (site_id, day, session_key)`,
  );

  await params.rawSql(`CREATE TABLE IF NOT EXISTS analytics_daily_rollups (
        site_id INTEGER NOT NULL,
        day DATE NOT NULL,
        visitors INTEGER NOT NULL DEFAULT 0,
        visits INTEGER NOT NULL DEFAULT 0,
        pageviews INTEGER NOT NULL DEFAULT 0,
        created_at TIMESTAMP DEFAULT NOW() NOT NULL,
        updated_at TIMESTAMP DEFAULT NOW() NOT NULL,
        CONSTRAINT analytics_daily_rollups_site_day_unique UNIQUE (site_id, day)
    )`);
  await params.rawSql(
    `CREATE INDEX IF NOT EXISTS analytics_daily_rollups_site_day_idx ON analytics_daily_rollups (site_id, day)`,
  );

  await params.rawSql(`CREATE TABLE IF NOT EXISTS analytics_daily_dimension_rollups (
        site_id INTEGER NOT NULL,
        day DATE NOT NULL,
        dimension TEXT NOT NULL,
        value TEXT NOT NULL,
        label TEXT NOT NULL,
        visitors INTEGER NOT NULL DEFAULT 0,
        visits INTEGER NOT NULL DEFAULT 0,
        pageviews INTEGER NOT NULL DEFAULT 0,
        created_at TIMESTAMP DEFAULT NOW() NOT NULL,
        updated_at TIMESTAMP DEFAULT NOW() NOT NULL,
        CONSTRAINT analytics_daily_dimension_site_day_dim_value_unique UNIQUE (site_id, day, dimension, value)
    )`);
  await params.rawSql(
    `CREATE INDEX IF NOT EXISTS analytics_daily_dimension_site_day_idx ON analytics_daily_dimension_rollups (site_id, day, dimension)`,
  );
}
